import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useAxios } from '../../utils/hook/useAxios';

export default function CheckoutForm({ VehiculeData }) {
  const stripe = useStripe();
  const elements = useElements();
  const axios = useAxios();
  const location = useLocation();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [paymentSucceeded, setPaymentSucceeded] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const reservationId = searchParams.get('reservationId');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements || isLoading) {
      return;
    }

    setIsLoading(true);
    setMessage(null);

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/checkout`,
        },
        redirect: 'if_required',
      });

      if (error) {
        setMessage(error.message || 'Le paiement a échoué.');
        return;
      }

      if (paymentIntent?.status === 'succeeded') {
        // Empêche un deuxième clic pendant la transition
        setMessage('Paiement effectué avec succès. Redirection...');
        setPaymentSucceeded(true);

        setTimeout(() => {
          window.location.href = `/guest/reservation/${reservationId}`;
        }, 500);

        return;
      }

      if (paymentIntent?.status === 'processing') {
        setMessage('Votre paiement est en cours de traitement.');
        return;
      }
    } catch (error) {
      console.error('Erreur confirmation paiement :', error);
      setMessage('Une erreur est survenue lors du paiement.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement
        id="payment-element"
        options={{
          layout: 'tabs',
        }}
      />

      <div className="form-check mt-2">
        <input
          className="form-check-input"
          type="checkbox"
          checked={checkConfirm}
          id="flexCheckChecked"
          onChange={(e) => setCheckConfirm(e.target.checked)}
        />

        <label className="form-check-label" htmlFor="flexCheckChecked">
          J'accepte effectuer ce paiement et les{' '}
          <a href="/help/conditions-de-locations">conditions de ventes</a> de Moovicar
        </label>
      </div>

      <p className="small text-muted mt-1">
        Vous pourrez contacter l'hôte directement après le paiement.
      </p>

      <button
        type="submit"
        disabled={isLoading || paymentSucceeded || !stripe || !elements || !checkConfirm}
        id="submit"
        className="btn btn-success text-white mt-3 col-md-3 w-100"
      >
        {isLoading ? <div className="spinner" /> : 'Réserver le voyage'}
      </button>

      {message && (
        <div id="payment-message" className="alert alert-danger mt-3">
          {message}
        </div>
      )}
    </form>
  );
}
